"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagEC = function FlagEC(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6,79.27H-193v60a7.07,7.07,0,0,0,7.06,7.06H209.54a7.07,7.07,0,0,0,7.06-7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6,12.18H-193V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "135.18",
    width: "409.6",
    height: "67.09",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.43,16.14,56-28.07v64A19.53,19.53,0,0,1,23.43,50.43l-19-17.09Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M31.64,41.3,16.71,27.87V5.62l27-23.16V35.92A7.24,7.24,0,0,1,31.64,41.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.08-.7V24.59L36.36,35.68V-11.23l7.37-6.31V35.92A7.24,7.24,0,0,1,31.64,41.3L16.71,27.87V5.62Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.17,16.14-32.41-28.07v64A19.52,19.52,0,0,0-12.89,55.44a19.52,19.52,0,0,0,13.07-5l19-17.09Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-8,41.3,6.89,27.87V5.62l-27-23.16V35.92a7.25,7.25,0,0,0,7.24,7.24A7.24,7.24,0,0,0-8,41.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-.48-.7V24.59L-12.76,35.68V-11.23l-7.37-6.31V35.92a7.25,7.25,0,0,0,7.24,7.24A7.24,7.24,0,0,0-8,41.3L6.89,27.87V5.62Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "248.23",
    y: "95.15",
    width: "3.53",
    height: "21.16",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "159.81",
    y: "95.15",
    width: "3.53",
    height: "21.16",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.43-37.9S9.34-61.24-7.85-58.16s-17.2,8-36.85,17.8c0,0,22.11,4.92,31.93,2.46,0,0,7.37,9.83,14.74,12.29H9.34Zm0,0",
    transform: "translate(194 123)",
    fill: "#5a4646"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.17-37.9S14.26-61.24,31.45-58.16s17.19,8,36.85,17.8c0,0-22.11,4.92-31.94,2.46,0,0-7.36,9.83-14.74,12.29H14.26Zm0,0",
    transform: "translate(194 123)",
    fill: "#5a4646"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.17-25.61H4.43V-38a7.28,7.28,0,0,1,7.28-7.28h.18A7.28,7.28,0,0,1,19.17-38Zm0,0",
    transform: "translate(194 123)",
    fill: "#5a4646"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.71-37.9A4.91,4.91,0,0,1,11.8-33,4.91,4.91,0,0,1,6.89-37.9a4.91,4.91,0,0,1,4.91-4.91,4.91,4.91,0,0,1,4.91,4.91Zm0,0",
    transform: "translate(194 123)",
    fill: "#e6e1cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.26-41.07l9.24,4.93a2,2,0,0,0,2.34-.35,2,2,0,0,0,0-2.82l-5.95-6H5.45a4.2,4.2,0,0,0-4.19,4.2Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffd0af"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.46-40.36h-7.4L.3-44.15a3.21,3.21,0,0,1,2.43-1.12H6.89v2.49a2.42,2.42,0,0,1-2.43,2.42Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffaf94"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M32.75-25.61a6.92,6.92,0,0,1-1.2-6.83,6.89,6.89,0,0,1,6.52,2.34,6.85,6.85,0,0,1,1.43,5.82c.49.83,1.09,1.9,1.75,3.17,0-.18,0-.36.08-.54a5.71,5.71,0,0,1,4.11-4,5.68,5.68,0,0,1,1.4,5.53,5.65,5.65,0,0,1-3.34,3.67c.62,1.41,1.23,2.94,1.8,4.55,0-.1,0-.19.07-.29a5.73,5.73,0,0,1,4.52-3.49A5.71,5.71,0,0,1,50.68-10a5.65,5.65,0,0,1-3.81,3.3A42.86,42.86,0,0,1,48.29,3.86H45.84a39.63,39.63,0,0,0-1.22-9.28A5.6,5.6,0,0,1,40-5.93a5.66,5.66,0,0,1-2.69-5,5.65,5.65,0,0,1,5.66.13l.17.14c-.53-1.51-1.09-2.95-1.66-4.29a5.62,5.62,0,0,1-4.81,0,5.66,5.66,0,0,1-3.22-4.65A5.64,5.64,0,0,1,39-20c-.67-1.3-1.29-2.39-1.76-3.21a6.85,6.85,0,0,1-4.51-2.38Zm0,0",
    transform: "translate(194 123)",
    fill: "#8cb400"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-9.15-25.61a6.92,6.92,0,0,0,1.2-6.83,6.92,6.92,0,0,0-6.53,2.34,6.87,6.87,0,0,0-1.42,5.82c-.5.83-1.09,1.9-1.75,3.17,0-.18,0-.36-.08-.54a5.72,5.72,0,0,0-4.11-4,5.73,5.73,0,0,0-1.41,5.53,5.66,5.66,0,0,0,3.35,3.67c-.62,1.41-1.23,2.94-1.8,4.55,0-.1,0-.19-.07-.29a5.73,5.73,0,0,0-4.52-3.49A5.71,5.71,0,0,0-27.08-10a5.65,5.65,0,0,0,3.81,3.3A42.86,42.86,0,0,0-24.69,3.86h2.46A39.62,39.62,0,0,1-21-5.42a5.6,5.6,0,0,0,4.67-.51,5.68,5.68,0,0,0,2.69-5,5.65,5.65,0,0,0-5.66.13l-.17.14c.53-1.51,1.09-2.95,1.67-4.29a5.6,5.6,0,0,0,4.8,0,5.63,5.63,0,0,0,3.21-4.65A5.62,5.62,0,0,0-15.42-20c.67-1.3,1.28-2.39,1.76-3.21a6.83,6.83,0,0,0,4.51-2.38Zm0,0",
    transform: "translate(194 123)",
    fill: "#8cb400"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8,28.43-39.79-15.79v64A19.54,19.54,0,0,0-20.26,67.73a19.49,19.49,0,0,0,13.06-5l19-17.09Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-15.41,53.59-.48,40.15V17.9l-27-23.16V48.2a7.24,7.24,0,0,0,7.24,7.24,7.28,7.28,0,0,0,4.85-1.85Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-7.85,11.58v25.3L-20.13,48V1.05L-27.5-5.26V48.2a7.24,7.24,0,0,0,7.24,7.24,7.28,7.28,0,0,0,4.85-1.85L-.48,40.15V17.9Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8,28.43,63.38-15.79v64A19.52,19.52,0,0,1,30.79,62.71l-19-17.09Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M39,53.59,24.08,40.15V17.9l27-23.16V48.2A7.25,7.25,0,0,1,39,53.59Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M31.45,11.58v25.3L43.73,48V1.05L51.1-5.26V48.2A7.25,7.25,0,0,1,39,53.59L24.08,40.15V17.9Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M36.36,11.23c0,20.35-11,36.84-24.56,36.84S-12.77,31.58-12.77,11.23s11-36.85,24.57-36.85S36.36-9.12,36.36,11.23Zm0,0",
    transform: "translate(194 123)",
    fill: "#69c3ff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-10.31,21.05H33.91l2.45-9.82L25.17,13.1a7.72,7.72,0,0,1-6.27-1.75L6.19.46A6.24,6.24,0,0,0,2.11-1,6.29,6.29,0,0,0-2.32.78l-8,8Zm0,0",
    transform: "translate(194 123)",
    fill: "#009b64"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.47,9.58l4.22-2.7L6.19.46A6.27,6.27,0,0,0-2.32.78l-8,8v2.46L2,8.77,4.14,9.86a5.42,5.42,0,0,0,5.33-.28Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-10.31,21.05l2.46,14.74L4.43,48.07H11.8l9.82-2.45,9.83-9.83,2.46-14.74Zm0,0",
    transform: "translate(194 123)",
    fill: "#5aa0e6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8,50.53c-14.9,0-27-17.63-27-39.3s12.12-39.3,27-39.3,27,17.63,27,39.3-12.12,39.3-27,39.3Zm0-73.69c-12.19,0-22.11,15.43-22.11,34.39S-.39,45.62,11.8,45.62,33.91,30.2,33.91,11.23,24-23.16,11.8-23.16Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffc88c"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-5.53,47.85a10.67,10.67,0,0,0-8.59-4.69,10.67,10.67,0,0,0-8.6,4.69A11.87,11.87,0,0,1-15,55.44a14.36,14.36,0,0,1,.86,4.92c0-6.08,3.67-11.14,8.59-12.51Zm0,0",
    transform: "translate(194 123)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-12.18,55.61s-.19,3.27-1.87,4.8l-.07,0C-15.8,58.82-16,55.55-16,55.55Zm0,0",
    transform: "translate(194 123)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M42.52,56.67H-18.92a1.21,1.21,0,0,1-1.21-1.21v0a1.22,1.22,0,0,1,1.21-1.22H42.52a1.22,1.22,0,0,1,1.21,1.22v0a1.21,1.21,0,0,1-1.21,1.21Zm0,0",
    transform: "translate(194 123)",
    fill: "#966446"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.14,60.36H-.54A4.87,4.87,0,0,1-5.4,55.5v-.12A4.86,4.86,0,0,1-.54,50.53H24.14A4.86,4.86,0,0,1,29,55.38v.12a4.87,4.87,0,0,1-4.86,4.86Zm0,0",
    transform: "translate(194 123)",
    fill: "#be915a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-10.31,54.21H-18.9a1.24,1.24,0,0,0-1.23,1.23,1.23,1.23,0,0,0,1.23,1.23h8.59Zm0,0",
    transform: "translate(194 123)",
    fill: "#b9b9b9"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8,60.36V82.8L2,80,6.89,60.36Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.34,60.36,4.43,77.55-5.4,75.1,2,60.36Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-.48,60.36l-7.37,9.82,7.37,2.46L4.43,60.36Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8,60.36V82.8L21.62,80,16.71,60.36Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.26,60.36l4.91,17.19L29,75.1,21.62,60.36Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.08,60.36l7.37,9.82-7.37,2.46L19.17,60.36Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-38,5.37l-3.53-3.56v-17.6H-38Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M65.12,1.81,61.59,5.37V-15.79h3.53Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagEC;
exports["default"] = _default;